module.exports = __webpack_public_path__ + "static/media/l2.b3eb4975.png";